import { render } from "./TopBarWarning.vue?vue&type=template&id=74af9693&scoped=true"
import script from "./TopBarWarning.vue?vue&type=script&lang=js"
export * from "./TopBarWarning.vue?vue&type=script&lang=js"

import "./TopBarWarning.vue?vue&type=style&index=0&id=74af9693&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74af9693"]])

export default __exports__